import {
  getPostApiV1ThreeLetterCodeClientAdminsUsersUserIdLoginRemindersMutationFetcher,
  getPostApiV1ThreeLetterCodeClientAdminsUsersUserIdLoginRemindersMutationKey,
} from '@fukuri-admins/apis/client/gen/endpoints';
import { useMutation } from '@fukuri-admins/hooks/common';
import { AxiosError } from 'axios';
import type { Key } from 'swr';

type Options = {
  onSuccess?: () => void;
  onError?: (error: AxiosError<{ errors?: string[] }>) => void;
};

/**
 * 初回ログイン未完了者への再招待メール個別送信フック（任意発火）
 * trigger(userId) で送信対象ユーザーの ID を渡す
 *
 * @param threeLetterCode - クライアントコード
 * @param options - コールバックオプション
 */
export const usePostClientUserLoginReminder = (threeLetterCode: string, options?: Options) =>
  useMutation(
    getPostApiV1ThreeLetterCodeClientAdminsUsersUserIdLoginRemindersMutationKey(threeLetterCode, 0),
    (_: Key, { arg }: { arg: number }) =>
      getPostApiV1ThreeLetterCodeClientAdminsUsersUserIdLoginRemindersMutationFetcher(
        threeLetterCode,
        arg
      ),
    options
  );
